import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#0A1121",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.274 12.003h11.813M18.274 14.816l2.813-2.813-2.813-2.813M14.812 15.375v3.375a1.08 1.08 0 0 1-1.023 1.125H4.585a1.08 1.08 0 0 1-1.023-1.125V5.25a1.077 1.077 0 0 1 1.023-1.125h9.204a1.08 1.08 0 0 1 1.023 1.125v3.375"
    }, null, -1)
  ]))]))
}
export default { render: render }